import { closeWebviewOnApp } from '~/services/app-interface';
import { useEnvironmentInfo, useIsClient } from '~/hooks';
import { useCallback } from 'react';

export const useGoBack = () => {
  const { isClient } = useIsClient();
  const { isWebview } = useEnvironmentInfo();

  const goBack = useCallback(
    ({ backType = 'history' }: { backType?: 'history' | 'close' } = {}) => {
      if (!isClient) return;

      if (backType === 'close') {
        if (isWebview) {
          closeWebviewOnApp().go();
        } else {
          globalThis.window.close();
        }
        return;
      }

      // 뒤로가기를 먼저 실행
      globalThis.window.history.back();

      const prev = globalThis.window.location.pathname;

      // 클로저를 활용해서
      // 시간이 지나고, page가 그대로 같다면, 더 이상 이전 페이지가 없는것으로 판단
      // 웹뷰의 경우에는 해당 케이스에서 웹뷰 close 실행
      setTimeout(() => {
        if (prev === globalThis.window.location.pathname) {
          closeWebviewOnApp().go();
        }
      }, 100);
    },
    [isClient, isWebview],
  );

  return {
    goBack,
  };
};
